import { styled } from '@mui/material/styles';

export const Content = styled('div')(({ theme, dividers }) => ({
  ...(dividers && {
    borderTop: `1px solid ${theme.color.grey[500]}`
  })
}));
